import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import { BasketProvider } from "@/context/BasketContext";
import { AuthProvider } from "@/context/AuthContext";
import { AuthModal } from "@/components/AuthModal";
import { InstallPrompt } from "@/components/InstallPrompt";
import { CartFab } from "@/components/CartFab";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import PaymentResult from "@/pages/PaymentResult";
import TrackOrder from "@/pages/TrackOrder";
import OwnerPanel from "@/pages/OwnerPanel";
import MyOrders from "@/pages/MyOrders";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <BasketProvider>
        <AuthProvider>
          <main id="top" className="relative">
            <SiteNav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/refund-cancellation-policy" element={<RefundPolicy />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/track" element={<TrackOrder />} />
              <Route path="/track/:id" element={<TrackOrder />} />
              <Route path="/owner" element={<OwnerPanel />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <SiteFooter />
            <CartFab />
            <AuthModal />
            <InstallPrompt />
          </main>
        </AuthProvider>
        <div
          aria-hidden="true"
          className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-multiply"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E\")",
          }}
        />
      </BasketProvider>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}

export default App;
